import * as React from 'react';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Stack,
  Paper,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { fetchLinktivity } from '../../../common/api/linktivities';
import { styled } from '@mui/system';
import DownloadIcon from '@mui/icons-material/Download';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import AccessLink from './AccessLink';
import StandardsDisplay from './StandardsDisplay';
import ProductPics from './ProductPics';
import GoogleShareToClassRoom from 'google-classroom-share';

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export default function LtvFull(props) {
  const { id } = props;
  const [singleLinkivity, setSingleLinkivity] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchLinktivity(id)
      .then((res) => {
        const linktivity = res.data;
        if (linktivity.demo_video_link) {
          linktivity.demo_video_link = linktivity.demo_video_link.replace(
            'youtu.be',
            'www.youtube.com/embed'
          );
        }
        setSingleLinkivity(linktivity);
      })
      .catch((err) => {
        console.error(err);
        setSingleLinkivity({});
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleTeacherGuideClick = (event) => {
    event.preventDefault();
    window.open(singleLinkivity.teacher_guide_link, '_blank', 'noopener');
  };

  const handleStudentPrintablesClick = (event) => {
    event.preventDefault();
    window.open(
      singleLinkivity.student_resource_link_printable,
      '_blank',
      'noopener'
    );
  };

  const handleStudentDigitalClick = (event) => {
    event.preventDefault();
    window.open(singleLinkivity.student_resource_link_gs, '_blank', 'noopener');
  };

  return (
    <>
      {loading ? (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <CircularProgress color='secondary' />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography textAlign={'left'}>
              {singleLinkivity.linktivity_description}
            </Typography>
          </Grid>
          <Grid item md={1}></Grid>
          <Grid item xs={12} md={10}>
            <AccessLink
              link={singleLinkivity.cloudfront_link}
              name={singleLinkivity.linktivity_name}
              desctription={singleLinkivity.linktivity_description}
            />
          </Grid>
          <Grid item md={1}></Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={7} lg={8}>
                {singleLinkivity && (
                  <ProductPics
                    demoVideoLink={singleLinkivity.demo_video_link}
                    linktivityName={singleLinkivity.linktivity_name}
                    picURLs={singleLinkivity.product_pics}
                  ></ProductPics>
                )}
              </Grid>
              <Grid item xs={12} md={5} lg={4}>
                <Stack
                  direction='column'
                  alignItems='flex-start'
                  justifyContent='flex-start'
                  spacing={1}
                  style={{ height: '100%' }}
                >
                  <Item elevation={0} square>
                    <Typography variant='h6'>Supplemental Materials</Typography>
                  </Item>
                  <Item elevation={0} square>
                    <Button
                      variant='outlined'
                      color='secondary'
                      onClick={handleTeacherGuideClick}
                      size='small'
                    >
                      <DownloadIcon style={{ marginRight: '5' }} />
                      Teacher Guide
                    </Button>
                  </Item>
                  <Item elevation={0} square>
                    <Button
                      variant='outlined'
                      color='primary'
                      onClick={handleStudentPrintablesClick}
                      size='small'
                    >
                      <DownloadIcon style={{ marginRight: '5' }} />
                      Printable Student Activity
                    </Button>
                  </Item>
                  <Item elevation={0} square>
                    <Button
                      variant='outlined'
                      color='tertiary'
                      onClick={handleStudentDigitalClick}
                      size='small'
                    >
                      <FileOpenIcon style={{ marginRight: '5' }} />
                      Digital Student Activity
                    </Button>
                  </Item>
                  <Item elevation={0} square>
                    <Typography variant='h6'>Standards Covered</Typography>
                  </Item>
                  {singleLinkivity.attached_standards &&
                  singleLinkivity.attached_standards.length > 0 ? (
                    <Item elevation={0} square>
                      <StandardsDisplay
                        standards={singleLinkivity.attached_standards}
                      />
                    </Item>
                  ) : (
                    <Item elevation={0} square>
                      <Typography variant='body2' textAlign={'left'}>
                        This LINKtivity is not aligned with any specific
                        standards.
                      </Typography>
                    </Item>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
